export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    font: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(51, 51, 51, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(0, 120, 215, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(51, 51, 51, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(0, 120, 215, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    height: 80
  },
  mb_widgets_infor: {},
  listArr: {
    list_link: [
      {
        id: 'shopping_cart',
        value: 'Inquiry Cart',
        path: '/cart_index',
        link: '/cart/index'
      },
      {
        id: 'user_login',
        value: 'Sign in',
        path: '/user_login',
        link: '/user/login'
      },
      // {
      //   id:'user_register',
      //   value: '注册',
      //   path: '/user_register',
      //   link: '/user/register'
      // },      
      // {
      //   id:'user_index',
      //   value: '会员中心',
      //   path: '/user_index',
      //   link: '/user/index'
      // }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/widgets/basic_loginregister/style.js